// export default {
//   sort: 2,
//   path: '/newEdit/:id',
//   name: 'NewEdit',
//   component: () => import('@/views/editOrder/newEdit'),
// }
export default {
  sort: 2,
  path: '/newEdit/:id',
  name: 'NewEdit',
  component: () => import('@/views/new/order/editOrder.vue'),
}



// WEBPACK FOOTER //
// ./src/router/modules/newEdit.js